import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/gestion_proyecto/ordenServicio';
import OrdenServicioList from './OrdenServicioList';

const ms2p = (state) => {
  return {
    ...state.proyecto_orden_servicio,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(OrdenServicioList);
